import React, { useEffect } from 'react';
import { Box, Grid, TextField } from '@mui/material';
// Dates
// import DateAdapter from '@mui/lab/AdapterMoment';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'moment/locale/es';
import { truthty } from 'utils/functions';
import { isNumber } from 'utils/math';
import { getQuoteExpiryDate } from 'utils/quoteCalculations';
import CustomDatePicker from './CustomDatePicker';
import FormSection from './FormSection';

// Todos los campos reservan la línea de ayuda (' '): así las filas de ambas columnas quedan a
// la misma altura y nada salta cuando aparece un error.
const helper = (errors, id, fallback = ' ') => (errors[id] ? errors[id][0] : fallback);

const getClientCodeHelper = (errors, clientCode, clientLookup) => {
  if (clientLookup.code === clientCode && clientLookup.notFound)
    return 'No existe un cliente con ese código.';
  return helper(errors, 'clientCode');
};

const getValidityHelper = (errors, startDate, validityDays) => {
  const expiryDate = getQuoteExpiryDate(startDate, validityDays);
  return helper(
    errors,
    'validityDays',
    expiryDate
      ? `Vence el ${expiryDate.format('DD/MM/YYYY')}`
      : 'Se calcula desde la fecha inicial',
  );
};

// Datos de cliente y de ejecutivo, arriba y lado a lado, antes de los productos.
const FormAbove = function (props) {
  const { controls, onChange, errors, actions, clientLookup } = props;
  const { clientCode } = controls;

  // Al ingresar el código se busca la empresa para mostrarla (la saga hace el debounce).
  useEffect(() => {
    if (isNumber(clientCode)) actions.getClientByCode({ clientCode });
  }, [clientCode, actions]);

  const clientNotFound = clientLookup.code === clientCode && clientLookup.notFound;
  const companyName =
    clientCode && clientLookup.code === clientCode ? clientLookup.name : controls.clientName;

  return (
    // Grid CSS en vez de <Grid container spacing>: sin márgenes negativos, los bordes coinciden
    // con los de las secciones de abajo.
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 7fr) minmax(0, 5fr)' },
        gap: 3,
      }}>
      <FormSection
        title="Datos del cliente"
        description="Ingrese el código del cliente o el nombre de la empresa.">
        <Grid container columnSpacing={2} rowSpacing={0.5}>
          <Grid item xs={12}>
            <TextField
              id="title"
              label="Descripción"
              variant="outlined"
              value={controls.title}
              onChange={onChange}
              error={truthty(errors.title)}
              helperText={helper(errors, 'title', 'Se muestra como Referencia en el PDF')}
              inputProps={{ maxLength: 255 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id="clientCode"
              label="Código cliente"
              variant="outlined"
              value={clientCode}
              onChange={onChange}
              error={truthty(errors.clientCode) || clientNotFound}
              helperText={getClientCodeHelper(errors, clientCode, clientLookup)}
              inputProps={{ maxLength: 6, inputMode: 'numeric' }}
              fullWidth
              disabled={controls.clientName.length > 0}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            {/* Con código, muestra la empresa encontrada; sin código, se ingresa a mano. */}
            <TextField
              id="clientName"
              label="Empresa cliente"
              variant="outlined"
              value={companyName}
              onChange={onChange}
              error={truthty(errors.clientName)}
              helperText={helper(errors, 'clientName')}
              inputProps={{ maxLength: 255 }}
              fullWidth
              disabled={clientCode.length > 0}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="atn"
              label="Nombre contacto cliente"
              variant="outlined"
              value={controls.atn}
              onChange={onChange}
              inputProps={{ maxLength: 255 }}
              error={errors.atn?.length > 0}
              helperText={helper(errors, 'atn')}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="esES">
              <CustomDatePicker
                id="startDate"
                label="Fecha inicial"
                value={controls.startDate}
                onChange={onChange}
                error={errors.startDate?.length > 0}
                helperText={helper(errors, 'startDate')}
                required
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="validityDays"
              label="Validez (días)"
              variant="outlined"
              value={controls.validityDays}
              onChange={onChange}
              inputProps={{ maxLength: 3, inputMode: 'numeric' }}
              error={errors.validityDays?.length > 0}
              helperText={getValidityHelper(errors, controls.startDate, controls.validityDays)}
              required
              fullWidth
            />
          </Grid>
        </Grid>
      </FormSection>
      <FormSection title="Datos del ejecutivo" description="Datos de su usuario; puede editarlos.">
        <Grid container rowSpacing={0.5}>
          <Grid item xs={12}>
            <TextField
              id="sender"
              label="Ejecutivo"
              variant="outlined"
              value={controls.sender}
              onChange={onChange}
              inputProps={{ maxLength: 255 }}
              error={errors.sender?.length > 0}
              helperText={helper(errors, 'sender')}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="phone"
              label="Teléfono"
              variant="outlined"
              value={controls.phone}
              onChange={onChange}
              inputProps={{ maxLength: 255 }}
              error={errors.phone?.length > 0}
              helperText={helper(errors, 'phone')}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="email"
              label="e-mail"
              variant="outlined"
              value={controls.email}
              onChange={onChange}
              inputProps={{ maxLength: 255 }}
              error={errors.email?.length > 0}
              helperText={helper(errors, 'email')}
              required
              fullWidth
            />
          </Grid>
        </Grid>
      </FormSection>
    </Box>
  );
};

export default FormAbove;
